{{ 'orderDetails.documents.' + resolveDocumentCategory(property) | cxTranslate }}
